import { Box, Card, Grid, Stack } from "@mui/material";
import { INicu } from "../types/interfaces/INicu";
import NicuDetailAddressCard from "./NicuDetailAddressCard";
import NicuDetailOtherInfoCard from "./NicuDetailOtherInfoCard";
import NicuDetailNicuCard from "./NicuDetailNicuCard";
import NicuStaffSummary from "./NicuStaffSummary";

//This function creates a nicu detail which includes nicu address, other info, nicu info 
//and staffs component.
export default function NicuDetail(props: {nicu: INicu}) {
    
    return (
        <Stack>
            <Box sx={{ flexGrow: 1 }}>            
                <Grid container columns={{xs: 4, sm: 8, md: 7, lg: 12, xl: 12}} spacing={2}>
                    <Grid item xs={12} sm={6} md={4}>
                        <Card variant="outlined">
                            <NicuDetailAddressCard nicu={props.nicu} />
                        </Card>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                        <Card variant="outlined">
                            <NicuDetailOtherInfoCard nicu={props.nicu} />
                        </Card>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                        <Card variant="outlined">
                            <NicuDetailNicuCard nicu={props.nicu} />
                        </Card>
                    </Grid>
                </Grid>   
            </Box>
            <NicuStaffSummary staffs = {props.nicu.Staff == null ? [] : props.nicu.Staff} />
        </Stack>
    );
}